var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "loginbg" },
    [
      _c("div", { staticClass: "nav-bar" }, [
        _c("div", { staticClass: "n-l" }, [
          _c("div", { staticClass: "logo" }, [
            _c("img", {
              staticClass: "logo-img",
              attrs: { src: _vm.logo_icon },
              on: {
                error: function($event) {
                  return _vm.dealErr($event)
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "empname" }, [_vm._v(_vm._s(_vm.empname))])
          ])
        ]),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _vm.hosturl == "gkzpsss"
          ? _c("div", { staticClass: "zs-list-box" }, [
              _c("div", { staticClass: "zs-list" }, [
                _c(
                  "div",
                  {
                    staticClass: "zs-list-item",
                    on: {
                      click: function($event) {
                        return _vm.toCateInfoPage("sa")
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "zs-img",
                      attrs: { src: require("../../../../static/news-02.png") }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "zs-text" }, [_vm._v("学校成果")]),
                    _vm._v(" "),
                    _c("i", { staticClass: "el-icon-arrow-right zs-r-icon" })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "zs-list-item",
                    on: {
                      click: function($event) {
                        return _vm.toCateInfoPage("tp")
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "zs-img",
                      attrs: { src: require("../../../../static/news-03.png") }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "zs-text" }, [_vm._v("人才政策")]),
                    _vm._v(" "),
                    _c("i", { staticClass: "el-icon-arrow-right zs-r-icon" })
                  ]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "in-warp" }, [
          _c("div", { staticClass: "content-l" }, [
            _c(
              "div",
              { staticClass: "zhaopin-lists" },
              [
                (_vm.planlist != null && _vm.planlist.length < 1) ||
                this.planlist == "" ||
                this.planlist == null
                  ? _c(
                      "div",
                      {
                        staticClass: "zhaopin-item",
                        staticStyle: {
                          "justify-content": "center",
                          "flex-direction": "column"
                        }
                      },
                      [
                        _c("img", {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: {
                            src: require("../../../../static/login-zhaopin-item-02.png")
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(1)
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.planlist, function(item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticClass: "zhaopin-item",
                      class:
                        _vm.planlist != null && _vm.planlist.length > 1
                          ? "zhaopin-item-two"
                          : ""
                    },
                    [
                      _c("div", { staticClass: "zp-l" }, [
                        _c("div", { staticClass: "zp-text" }, [
                          _c("div", { staticClass: "zp-title" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "zp-p" }, [
                            _vm._v(_vm._s(_vm._f("formatStatus")(item.status)))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "zp-p2" }, [
                            _vm._v(
                              "\n                  您可以先点击下方立即查看按钮查看本次招聘是否有您希望报考的岗位，再决定是否进行注册和报名\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "zp-btn",
                              on: {
                                click: function($event) {
                                  return _vm.openPositions(item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  立即查看\n                "
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._m(2, true)
                    ]
                  )
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-r" }, [
            _c(
              "div",
              { staticStyle: { position: "sticky", top: "80px" } },
              [
                _vm.loginTishiShow
                  ? _c(
                      "div",
                      {
                        staticClass: "login-tishi",
                        class: _vm.loginTishi ? "tishi" : ""
                      },
                      [
                        _c("span", { staticClass: "tishi-text" }, [
                          _vm._v(
                            "请先登录后才能投递，若无账号请先进行注册后再登陆"
                          )
                        ]),
                        _vm._v(" "),
                        _c("i", { staticClass: "icon el-icon-caret-right" })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-card",
                  { staticClass: "login-form-layout" },
                  [
                    _c(
                      "el-tabs",
                      {
                        attrs: { stretch: true },
                        model: {
                          value: _vm.activeName,
                          callback: function($$v) {
                            _vm.activeName = $$v
                          },
                          expression: "activeName"
                        }
                      },
                      [
                        _c(
                          "el-tab-pane",
                          { attrs: { label: "账号登录", name: "login" } },
                          [
                            _c(
                              "el-form",
                              {
                                ref: "loginForm",
                                attrs: {
                                  autoComplete: "on",
                                  model: _vm.loginForm,
                                  rules: _vm.loginRules,
                                  "label-position": "left"
                                }
                              },
                              [
                                _c("div", { staticStyle: { height: "10px" } }),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "username" } },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        ref: "loginuser",
                                        attrs: {
                                          name: "username",
                                          type: "text",
                                          autoComplete: "on",
                                          placeholder: "请输入手机号"
                                        },
                                        model: {
                                          value: _vm.loginForm.username,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.loginForm,
                                              "username",
                                              $$v
                                            )
                                          },
                                          expression: "loginForm.username"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "prefix" },
                                            slot: "prefix"
                                          },
                                          [
                                            _c("svg-icon", {
                                              staticClass:
                                                "color-main inputSvg",
                                              attrs: {
                                                "icon-class": "icon-zhanghao"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "password" } },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        attrs: {
                                          name: "password",
                                          type: _vm.pwdType,
                                          autoComplete: "on",
                                          placeholder: "请输入密码"
                                        },
                                        nativeOn: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.handleLogin.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.loginForm.password,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.loginForm,
                                              "password",
                                              $$v
                                            )
                                          },
                                          expression: "loginForm.password"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "prefix" },
                                            slot: "prefix"
                                          },
                                          [
                                            _c("svg-icon", {
                                              staticClass:
                                                "color-main inputSvg",
                                              attrs: {
                                                "icon-class": "icon-mima"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "suffix" },
                                            on: { click: _vm.showPwd },
                                            slot: "suffix"
                                          },
                                          [
                                            _c("svg-icon", {
                                              staticClass:
                                                "color-main inputSvgpass",
                                              attrs: {
                                                "icon-class": _vm.icon_login
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { position: "relative" },
                                    attrs: { prop: "code" }
                                  },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        staticStyle: { width: "50%" },
                                        attrs: {
                                          "auto-complete": "off",
                                          placeholder: "验证码"
                                        },
                                        nativeOn: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.handleLogin.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.loginForm.code,
                                          callback: function($$v) {
                                            _vm.$set(_vm.loginForm, "code", $$v)
                                          },
                                          expression: "loginForm.code"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "prefix" },
                                            slot: "prefix"
                                          },
                                          [
                                            _c("svg-icon", {
                                              staticClass:
                                                "color-main inputSvg",
                                              attrs: {
                                                "icon-class": "icon-yanzhengma"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticStyle: { float: "right" },
                                      attrs: { src: _vm.codeData },
                                      on: { click: _vm.getCode }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: {
                                      "margin-bottom": "20px",
                                      "text-align": "center"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          height: "50px",
                                          "border-radius": "4px",
                                          "background-color": "#2578f8",
                                          "font-size": "18px"
                                        },
                                        attrs: {
                                          type: "primary",
                                          loading: _vm.loading
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.handleLogin.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      登录\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "center"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "14px",
                                          color: "#191919"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      忘记密码？\n                      "
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: { click: _vm.resetwindow }
                                          },
                                          [_vm._v("点击找回")]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tab-pane",
                          { attrs: { label: "用户注册", name: "reg" } },
                          [
                            _c(
                              "el-form",
                              {
                                ref: "regForm",
                                attrs: {
                                  autoComplete: "on",
                                  model: _vm.regForm,
                                  rules: _vm.regRules,
                                  "label-position": "left"
                                }
                              },
                              [
                                _c("div", { staticStyle: { height: "10px" } }),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "username" } },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        attrs: {
                                          name: "username",
                                          type: "text",
                                          autoComplete: "on",
                                          placeholder:
                                            "手机号码将用于身份标识和接收招聘动态"
                                        },
                                        model: {
                                          value: _vm.regForm.username,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.regForm,
                                              "username",
                                              $$v
                                            )
                                          },
                                          expression: "regForm.username"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "prefix" },
                                            slot: "prefix"
                                          },
                                          [
                                            _c("svg-icon", {
                                              staticClass:
                                                "color-main inputSvg",
                                              attrs: {
                                                "icon-class": "icon-zhanghao"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "password" } },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        attrs: {
                                          name: "password",
                                          type: _vm.regPwdType,
                                          autoComplete: "on",
                                          placeholder:
                                            "请输入登录密码, 密码长度大于10,且必须包含大写、小写、数字、特殊字符！",
                                          "show-password": ""
                                        },
                                        model: {
                                          value: _vm.regForm.password,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.regForm,
                                              "password",
                                              $$v
                                            )
                                          },
                                          expression: "regForm.password"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "prefix" },
                                            slot: "prefix"
                                          },
                                          [
                                            _c("svg-icon", {
                                              staticClass:
                                                "color-main inputSvg",
                                              attrs: {
                                                "icon-class": "icon-mima"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "checkpassword" } },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        attrs: {
                                          name: "checkpassword",
                                          type: _vm.regPwdType,
                                          autoComplete: "on",
                                          placeholder: "请确认登录密码",
                                          "show-password": ""
                                        },
                                        model: {
                                          value: _vm.regForm.checkpassword,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.regForm,
                                              "checkpassword",
                                              $$v
                                            )
                                          },
                                          expression: "regForm.checkpassword"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "prefix" },
                                            slot: "prefix"
                                          },
                                          [
                                            _c("svg-icon", {
                                              staticClass:
                                                "color-main inputSvg",
                                              attrs: {
                                                "icon-class": "icon-mima"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "regcode" } },
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 14 } },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { float: "left" },
                                                attrs: {
                                                  "auto-complete": "off",
                                                  placeholder:
                                                    "请输入手机验证码"
                                                },
                                                model: {
                                                  value: _vm.regForm.regcode,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.regForm,
                                                      "regcode",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "regForm.regcode"
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: { slot: "prefix" },
                                                    slot: "prefix"
                                                  },
                                                  [
                                                    _c("svg-icon", {
                                                      staticClass:
                                                        "color-main inputSvg",
                                                      attrs: {
                                                        "icon-class":
                                                          "icon-yanzhengma"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 10 } },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: {
                                                  height: "50px",
                                                  width: "100%",
                                                  "border-radius":
                                                    "0 4px 4px 0",
                                                  float: "right"
                                                },
                                                attrs: {
                                                  type: "primary",
                                                  size: "medium",
                                                  loading: _vm.captchaloading,
                                                  disabled: !_vm.canClick
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.handlegetCaptcha.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(_vm.getCodeText) +
                                                    "\n                        "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: {
                                      "margin-bottom": "60px",
                                      "text-align": "center"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          height: "50px",
                                          "border-radius": "4px",
                                          "background-color": "#2578f8",
                                          "font-size": "18px"
                                        },
                                        attrs: {
                                          type: "primary",
                                          loading: _vm.regloading
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.handleReg.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      注册\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "zp-notice" }, [
        _c(
          "div",
          { staticClass: "notice-lists" },
          [
            _vm._l(_vm.noticeList.slice(0, 3), function(notice, index) {
              return _c(
                "div",
                {
                  staticClass: "notice-item",
                  on: {
                    click: function($event) {
                      return _vm.openNotice(notice)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "l" }, [
                    _c("div", { staticClass: "notice-xh" }, [
                      _vm._v(_vm._s(index + 1))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "c" },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: notice.title,
                            placement: "top-start"
                          }
                        },
                        [
                          _c("div", { staticClass: "notice-title" }, [
                            _vm._v(_vm._s(notice.title))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "notice-sendtime" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("formatDateTime")(notice.sendTime)) +
                            "\n          "
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(3, true)
                ]
              )
            }),
            _vm._v(" "),
            _vm.noticeList.length < 1
              ? _c("div", { staticClass: "notice-item" }, [_vm._m(4)])
              : _vm._e(),
            _vm._v(" "),
            _vm.noticeList.length > 3
              ? _c(
                  "div",
                  { staticClass: "notice-item", on: { click: _vm.openwindow } },
                  [_vm._m(5), _vm._v(" "), _vm._m(6)]
                )
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "loginman" },
        [
          _vm.showpub
            ? [
                _c("Pub", {
                  ref: "noticeShow",
                  attrs: { empId: _vm.empId },
                  on: { cancel: _vm.closewindow }
                })
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showreset
            ? [_c("Reset", { on: { cancel: _vm.closereset } })]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("Foot"),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            top: "5vh",
            width: "80%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("el-card", [
            _c(
              "div",
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading"
                      }
                    ],
                    ref: "PosTable",
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.poslist, height: "700", border: "" }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "岗位编号",
                        width: "100",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [_vm._v(_vm._s(scope.row.code))]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.columnsVisible.employerName && _vm.hosturl != "gxzzzy"
                      ? _c("el-table-column", {
                          attrs: { label: "用人单位", align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(_vm._s(scope.row.employerName))
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3426381391
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "岗位名称", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(scope.row.employingPositionName) +
                                  "\n            "
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.columnsVisible.courseTitle
                      ? _c("el-table-column", {
                          attrs: { label: "课程名称", align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(_vm._s(scope.row.courseTitle) + " ")
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3373226827
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.columnsVisible.courseCore
                      ? _c("el-table-column", {
                          attrs: { label: "是否核心课程", align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(_vm._s(scope.row.courseCore) + " ")
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4173950064
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "招聘人数", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm._f("filterPeopleCount")(
                                    scope.row.peopleCount
                                  )
                                ) + "\n            "
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.columnsVisible.employingPositionName2
                      ? _c("el-table-column", {
                          attrs: { label: "岗位类别等级", align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(scope.row.employingPositionName2)
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            946415443
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.columnsVisible.specialtyShow
                      ? _c("el-table-column", {
                          attrs: {
                            label: "专业",
                            width: "200",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: "",
                                          placement: "top"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "content",
                                              fn: function() {
                                                return [
                                                  _c("div", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.brMag(
                                                          scope.row
                                                            .specialtyShow
                                                        )
                                                      )
                                                    }
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.subMag(
                                                scope.row.specialtyShow
                                              )
                                            )
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            202518134
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "是否全日制", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(scope.row.isFullday == 1 ? "是" : "否") +
                                  "\n            "
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "学历学位", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm._f("filterVALUECODE")(
                                    scope.row.educationLevelCid,
                                    "JYJLeducationLevelCid"
                                  )
                                ) +
                                  "(及以上)； " +
                                  _vm._s(
                                    _vm._f("filteXW")(
                                      scope.row.degreeCid,
                                      "JYJLeducationDegreeCid"
                                    )
                                  )
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "年龄", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm._f("filterAge")(
                                    scope.row.age,
                                    scope.row.minAge
                                  )
                                )
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "职称或职(执)业资格", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(scope.row.qualificationText) +
                                  "\n          "
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "政治面貌", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm._f("filterVALUECODE")(
                                    scope.row.politicalCid,
                                    "JCXXpoliticalCid2"
                                  )
                                )
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.columnsVisible.others
                      ? _c("el-table-column", {
                          attrs: {
                            label: "其他条件",
                            align: "center",
                            "show-overflow-tooltip": true
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [_vm._v(_vm._s(scope.row.others))]
                                }
                              }
                            ],
                            null,
                            false,
                            736340202
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.columnsVisible.examType || _vm.columnsVisible.isAppraise
                      ? _c("el-table-column", {
                          attrs: { label: "考试方式", align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm._f("filterExam")(
                                            scope.row.examType,
                                            scope.row.examOpen,
                                            scope.row.examTypeOpen,
                                            scope.row.isAppraise
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4227864287
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.columnsVisible.employerType
                      ? _c("el-table-column", {
                          attrs: { label: "用人方式", align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(_vm._s(scope.row.employerType))
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            914016080
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.columnsVisible.memo
                      ? _c("el-table-column", {
                          attrs: {
                            label: "备注",
                            align: "center",
                            "show-overflow-tooltip": true
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [_vm._v(_vm._s(scope.row.memo))]
                                }
                              }
                            ],
                            null,
                            false,
                            334291447
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.columnsVisible.endDate
                      ? _c("el-table-column", {
                          attrs: { label: "报名截止时间", align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDateTimess")(
                                          scope.row.endDate
                                        )
                                      )
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1322955453
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.columnsVisible.phone
                      ? _c("el-table-column", {
                          attrs: { label: "咨询电话", align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [_vm._v(_vm._s(scope.row.phone))]
                                }
                              }
                            ],
                            null,
                            false,
                            2034370561
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "操作",
                        fixed: "right",
                        width: "120",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.sfbm == 1 &&
                              scope.row.recruitPlans.status < 90
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleApp(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("投递\n              ")]
                                  )
                                : _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: "info",
                                        disabled: ""
                                      }
                                    },
                                    [_vm._v("未开始/已结束\n              ")]
                                  )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.noticedialogVisible == true
        ? _c("div", { staticClass: "pub-home" }, [
            _c("div", { staticClass: "main" }, [
              _c("div", { staticClass: "main-header2" }, [
                _c("h3", [_vm._v(_vm._s(_vm.notice.title))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "main-body2" }, [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.notice.content) }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btns" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.colosNoticedialogVisible }
                    },
                    [_vm._v("\n          确认\n        ")]
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "n-r" }, [
      _c("span", { staticClass: "n-text" }, [_vm._v("您好，欢迎您，请先登录")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "zp-l", staticStyle: { "margin-left": "0" } },
      [
        _c("div", { staticClass: "zp-text" }, [
          _c(
            "div",
            {
              staticClass: "zp-title",
              staticStyle: {
                width: "auto",
                color: "rgba(0, 0, 0, 0.4)",
                "font-size": "24px"
              }
            },
            [
              _vm._v(
                "\n                  目前暂无招聘，请在报名时间段登录\n                "
              )
            ]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "zp-r" }, [
      _c("img", {
        attrs: { src: require("../../../../static/login-zhaopin-item.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "r" }, [
      _c("i", { staticClass: "icon el-icon-arrow-right" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c", staticStyle: { width: "100%" } }, [
      _c(
        "div",
        {
          staticClass: "notice-title",
          staticStyle: {
            color: "#0080ff",
            "font-weight": "bold",
            "font-size": "18px",
            "text-align": "center",
            width: "100%"
          }
        },
        [_vm._v("\n            暂无通知公告\n          ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c" }, [
      _c(
        "div",
        {
          staticClass: "notice-title",
          staticStyle: {
            color: "#0080ff",
            "font-weight": "bold",
            "font-size": "18px",
            "margin-left": "5px"
          }
        },
        [_vm._v("\n            查看全部公告\n          ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "r" }, [
      _c("i", {
        staticClass: "icon el-icon-arrow-right",
        staticStyle: { color: "#0080ff" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f367a3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f367a3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/components/Main.vue
// module id = null
// module chunks = 